import * as React from "react";
import { forwardRef } from "react";
const SvgBarcodeLg = ({
  title,
  titleId,
  ...props
}, ref) => /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", fill: "none", viewBox: "0 0 49 48", ref, "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("path", { stroke: "#E5E6E6", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: 3, d: "M6.611 10v28m10-28v28m8-28v28m10-28v28m8-28v28" }));
const ForwardRef = forwardRef(SvgBarcodeLg);
export { ForwardRef as ReactComponent };
